import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";
import { toast } from "react-toastify";

export const GetAllPatientList = createAsyncThunk(
    "patient/GetAllPatientList",
    async (body) => {
        try {
            const response = await apiInstance.post("profiles/patientList", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);

export const GetPatientDetails = createAsyncThunk(
    "patient/GetPatientDetails",
    async (id) => {
        try {
            const response = await apiInstance.get(`profiles/patientView/${id}`);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);
